import React from 'react';
import { useAnimateOnView } from '../../hooks/useIntersectionObserver';
import { disorders } from '../../data/disorders';
import './DisordersSection.css';

const DisordersSection: React.FC = () => {
  const [ref, shouldAnimate] = useAnimateOnView();

  return (
    <section
      ref={ref}
      className={`disorders-section section-padding${shouldAnimate ? ' loaded' : ''}`}
      id="disorders"
    >
      <div className="container">
        <div className="section-header ds-header">
          <span className="ds-eyebrow">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 21c-4.5-3-8-6.5-8-10.5A5.5 5.5 0 0 1 9.5 5c1.1 0 2.1.4 3 1.1L12 6.1l-.5.1c.9-.7 1.9-1.1 3-1.1A5.5 5.5 0 0 1 20 10.5c0 4-3.5 7.5-8 10.5Z" />
            </svg>
            Áreas de Especialización
          </span>
          <h2 className="section-title ds-title">
            <span>Estamos para lo que estés atravesando</span>
          </h2>
          <p className="section-subtitle ds-subtitle">
            Desde conflictos de pareja hasta ansiedad y depresión, cubrimos las principales necesidades de
            salud mental
          </p>
        </div>

        <div className="ds-grid">
          {disorders.map((disorder, index) => (
            <div
              key={disorder.id}
              className="ds-card animate-in"
              style={{ '--delay': `${0.15 + index * 0.06}s` } as React.CSSProperties}
            >
              <div className="ds-card__icon">
                <i className={disorder.icon} aria-hidden="true"></i>
              </div>
              <h3 className="ds-card__title">{disorder.title}</h3>
              <p className="ds-card__desc">{disorder.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DisordersSection;
